// @flow
import { fetchBidderDataIfNeeded, getAuthToken } from '../../../redux/modules/user';
import { fetchItemFacetsIfNeeded, getItemFacets } from '../../../redux/modules/itemFacets';
import { fetchItemsIfNeeded, getItem } from '../../../redux/modules/item';
import { fetchSimilarItemsV3IfNeeded, getSimilarItemIds } from '../../../redux/modules/similarItemsV3';
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchInvoiceIfNeeded } from '../../../redux/modules/checkout';
import { fetchItemDetailsIfNeeded } from '../../../redux/modules/itemDetail';
import { fetchSellersIfNeeded } from '../../../redux/modules/seller';
import { getFacetIds } from '../../../utils/ItemPageUtils';
import { recordAnalyticsForCheckoutConfirmationPageView } from '../../../redux/modules/analytics';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch, getState } = store;
    const sellerId = Number(params.sellerId);
    const itemId = Number(params.itemId);
    const authToken = getAuthToken(getState());

    return Promise.all([
        dispatch(fetchItemsIfNeeded([itemId])),
        dispatch(fetchItemDetailsIfNeeded([itemId])),
        dispatch(fetchItemFacetsIfNeeded([itemId])),
        dispatch(fetchSellersIfNeeded([sellerId])),
        dispatch(fetchBidderDataIfNeeded(authToken, true)),
    ]).then(() => {
        const item = getItem(getState(), itemId);
        const facets = getItemFacets(getState(), itemId);
        const categoryIds = getFacetIds(facets);
        const { sellerId, title } = item;
        const similarItemInfo = {
            categoryIds,
            itemId,
            sellerId,
            title,
        };

        return Promise.all([
            dispatch(fetchSimilarItemsV3IfNeeded(similarItemInfo)),
            dispatch(fetchInvoiceIfNeeded(item.catalogId)),
        ]).then(() => {
            const similarItemIds = getSimilarItemIds(getState(), itemId);
            return Promise.all([
                dispatch(fetchItemsIfNeeded(similarItemIds)),
                dispatch(recordAnalyticsForCheckoutConfirmationPageView()),
            ]);
        });
    });
};
